// extracted by css-extract-rspack-plugin
export default {"annotation":"Form__annotation--dn03W","contractInfoBox":"Form__contractInfoBox--ujmPQ","label":"Form__label--jI3Ri","text":"Form__text--LAp5G","button":"Form__button--m6JJD"};